/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
const { toCamelCase } = require('js-convert-case');

export interface IPreviewTemplateMethods extends IPluginMethodMap {
  getPreviewTemplateSync(args: any): any;
}

export class PreviewTemplateService implements IAgentPlugin {
  readonly methods: IPreviewTemplateMethods;
  constructor() {
    this.methods = {
      getPreviewTemplateSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    const result: any = {
      preview: {},
    };
    result.preview.credentialName = args?.credentialMeta?.templateName;
    result.preview.credentialLogo = args?.credentialMeta?.templateLogo?.base64;
    result.preview.credentialDescription =
      args?.credentialMeta?.templateDescription;
    result.preview.credentialBanner =
      args?.credentialMeta?.templateBanner?.base64;
    result.preview.credentialList = args?.credentialList;
    return result;
  }
}
